
import { Component, Prop, Vue } from "vue-property-decorator";
import Validation from "@/components/Validation.vue";
import Upload from "@/components/Upload.vue";

@Component({
  components: {
    Validation,
    Upload
  }
})
export default class WineFormUpload extends Vue {
  @Prop({})
  public v?: any;

  @Prop({})
  public fileExtension?: any;

  @Prop({ default: false })
  public disabled!: any;

  @Prop({})
  public maxFileSize?: string;

  public hasMaxSizeErr = false;

  public handleFile(file: any) {
    this.hasMaxSizeErr = false;
    if (file && this.maxFileSize && file.size > Number(this.maxFileSize)) {
      this.$nextTick(() => {
        this.hasMaxSizeErr = true;
      });

      return;
    }

    this.$emit("file", file);
  }
}
